import Link from "next/link";
import { Text } from "@/components/ui/text";
import { cn } from "@/lib/utils";
import type { Dictionary } from "../../../dictionaries";

interface SecuredByProps {
  className?: string;
  dictionary: Dictionary;
}

export function SecuredBy({ className, dictionary }: SecuredByProps) {
  return (
    <div className={cn("text-center", className)}>
      <Text variant="muted" className="text-xs">
        {dictionary.checkout.securedBy}{" "}
        <Link
          href="https://snippe.sh"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold hover:underline"
        >
          Snippe
        </Link>
      </Text>
    </div>
  );
}
